import React, { Component } from 'react';
import PropTypes from 'prop-types';


export default class DropDownMobile extends Component {
  constructor(props) {
    super(props);
    this.handleDropDown = this.handleDropDown.bind(this);
    this.state = {
      opened: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { opened } = this.state;
    if (nextProps.toggle && !opened) this.setState({ opened: nextProps.toggle });
  }

  handleDropDown() {
    const { opened } = this.state;
    this.setState({ opened: !opened });
  }

  render() {
    const { className, image, isPhone, title, content } = this.props;
    const { opened } = this.state;
    return (
      <div className={ `dropdown-mobile ${className}` } onClick={ this.handleDropDown }>
        <div className={ `dropdown-mobile__container ${opened || !isPhone ? '-opened-container' : ''}` }>
          <div className="dropdown-mobile__container__input">
            <img alt="" className="dropdown-mobile__container__input__image" src={ `${image}` } />
            <span className="dropdown-mobile__container__input__title">
              { title }
            </span>
            { isPhone
              ? (
                <span className={ `dropdown-mobile__container__input__arrow hundredicons-arrow-down-filled ${opened ? '-opened' : ''}` } />
              ) : null
            }
          </div>
          <div className={ `dropdown-mobile__container__expand ${opened || !isPhone ? '-opened-content' : ''}` }>
            <span className="dropdown-mobile__container__expand__content">
              { content }
            </span>
          </div>
        </div>
      </div>
    );
  }
}

DropDownMobile.defaultProps = {
  className: '',
  isPhone: false,
};

DropDownMobile.propTypes = {
  className: PropTypes.string,
  content: PropTypes.node.isRequired,
  image: PropTypes.string.isRequired,
  isPhone: PropTypes.bool,
  title: PropTypes.string.isRequired,
  toggle: PropTypes.bool.isRequired,
};
